import {get} from "lodash";
import React from "react";
import {FieldProps, useRecordContext} from "react-admin";

export const DriverField = (props: FieldProps & { source: string }) => {
  const record = useRecordContext(props);
  const value = get(record, props.source);
  return (
    <>
      {value && value
        ? `${value.surname} ${value.name}`
        : null}
    </>
  );
};
